import React from 'react';
import { smoothScroll } from '../utils/scroll';
import './Footer.css';

interface ContactItem {
  icon: string;
  title: string;
  desc: string;
  link: string;
  linkText: string;
  color: string;
  links?: Array<{
    href: string;
    label: string;
    icon: React.ReactNode;
  }>;
}

interface FooterProps {
  onPrivacyClick: () => void;
}

const SocialIcon: React.FC<{ type: 'facebook' | 'instagram' }> = ({ type }) => {
  const common = {
    width: 18,
    height: 18,
    viewBox: '0 0 24 24',
    fill: 'currentColor',
    style: { display: 'inline-block', verticalAlign: 'text-bottom' as const },
    'aria-hidden': true as const,
  };

  if (type === 'facebook') {
    return (
      <svg {...common}>
        <path d="M22 12a10 10 0 1 0-11.5 9.9v-7h-2.5V12h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9c1.1 0 2.2.2 2.2.2v2.4h-1.2c-1.2 0-1.6.8-1.6 1.5V12h2.7l-.4 2.9h-2.3v7A10 10 0 0 0 22 12Z" />
      </svg>
    );
  }

  return (
    <svg {...common}>
      <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5Zm10 2H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3Z" />
      <path d="M12 7a5 5 0 1 1 0 10a5 5 0 0 1 0-10Zm0 2a3 3 0 1 0 0 6a3 3 0 0 0 0-6Z" />
      <path d="M17.5 6.5a1 1 0 1 1 0 2a1 1 0 0 1 0-2Z" />
    </svg>
  );
};

const Footer: React.FC<FooterProps> = ({ onPrivacyClick }) => {
  const contacts: ContactItem[] = [
    { icon: '📧', title: 'Email', desc: 'Per informazioni generali, iscrizioni e partnership.', link: 'mailto:info@giocopertutti.it', linkText: 'info@giocopertutti.it', color: 'blue' },
    // { icon: '💬', title: 'Discord', desc: 'Unisciti alla community online per restare aggiornato.', link: '#', linkText: 'Entra su Discord', color: 'coral' },
    {
      icon: '📱',
      title: 'Social Media',
      desc: 'Seguici per eventi, foto e aggiornamenti in tempo reale.',
      link: '',
      linkText: '',
      color: 'yellow',
      links: [
        { href: 'https://www.facebook.com/profile.php?id=61583724453103', label: '', icon: <SocialIcon type="facebook" /> },
        { href: 'https://www.instagram.com/gioco_per_tutti/', label: '', icon: <SocialIcon type="instagram" /> },
      ],
    },
    { icon: '📍', title: 'Dove siamo', desc: 'Via Per Mare, 80 74020,\n Maruggio (TA)', link: '', linkText: '', color: 'light-blue' },
  ];

  return (
    <footer id="contatti">
      <div className="footer-container">
        <h2 style={{marginTop: 0, marginBottom: '24px'}}>Contattaci</h2>
        <div className="contacts-grid">
          {contacts.map((contact, index) => (
            <div key={index} className={`card contact-card contact-card-${index + 1}`}>
              <div style={{fontSize: '32px', marginBottom: '12px'}}>{contact.icon}</div>
              <h3>{contact.title}</h3>
              <p className="lead" style={{fontSize: '15px', marginBottom: '12px',  whiteSpace: 'pre-line'}}>{contact.desc}</p>
              {contact.links && contact.links.length > 0 && (
                <div style={{ marginTop: '12px', display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                  {contact.links.map((item) => (
                    <a
                      key={item.label}
                      className="cta secondary"
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={item.label}
                      style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}
                    >
                      {item.icon}
                      {item.label}
                    </a>
                  ))}
                </div>
              )}
              {contact.link !== '' && (
                contact.link.startsWith('mailto:') ? (
                  <a className="cta secondary" href={contact.link} style={{display: 'inline-block'}}>
                    {contact.linkText}
                  </a>
                ) : (
                  <a className="cta secondary" href={contact.link} onClick={(e) => { e.preventDefault(); smoothScroll(contact.link); }} style={{display: 'inline-block'}}>
                    {contact.linkText}
                  </a>
                )
              )}
            </div>
          ))}
        </div>
        <div className="footer-bottom">
          <div>
            <strong>Gioco per tutti - GPT</strong> • Associazione culturale senza scopo di lucro<br />
            <small>Codice di condotta: rispetto, inclusione, zero toxic play.</small><br />
            <small>C.F/P.IVA: 90290520734 </small>
            <small>Via Per Mare, 80 74020, Maruggio (TA)</small>
          </div>
          <div style={{ marginTop: '16px', display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            <a
              className="cta secondary"
              href="/GPT%20STATUTO.pdf"
              target="_blank"
              rel="noopener noreferrer"
              download
            >
              📄 Scarica il PDF dello statuto
            </a>
            <button
              className="cta secondary"
              onClick={onPrivacyClick}
              style={{ cursor: 'pointer', border: '1px solid var(--border)' }}
            >
              🔒 Privacy Policy
            </button>
          </div>
          {/* <div className="hero-actions">
            <a className="cta secondary" href="#membership" onClick={(e) => { e.preventDefault(); smoothScroll('#membership'); }}>
              Iscriviti
            </a>
            <a className="cta" href="mailto:info@giocopertutti.it">Scrivici</a>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;



